import React from 'react';
import authRoles from '../../../auth/authRoles';
import CalendarView from './CalendarView';

const CalendarConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/calendar',
			element: (
				<React.Suspense fallback={<>...</>}>
					<CalendarView />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default CalendarConfig;
